import {
  trigger,
  useAlviSession,
  useCart
} from '@smu-chile/pkg-unimarc-hooks'

type AnyHandler = (...args: unknown[]) => unknown

/**
 * Guards cart actions behind the presence of a delivery address.
 * When the user is logged in but has no address set, calling a guarded
 * handler opens the Store Locator modal instead of running the action.
 * Logged-out users bypass the guard so the existing login flow applies.
 */
export const useAddressGuard = () => {
  const { isLoggedIn } = useAlviSession()
  const { data } = useCart()

  const hasAddress = Boolean(data?.address)
  const requiresAddressPrompt = isLoggedIn && !hasAddress

  const promptAddress = () => {
    trigger({ data: { show: true }, eventType: 'storeLocator' })
  }

  const guard = <T extends AnyHandler>(fn?: T): T => {
    return ((...args: Parameters<T>) => {
      if (requiresAddressPrompt) {
        promptAddress()
        return
      }
      return fn?.(...args)
    }) as T
  }

  return { requiresAddressPrompt, promptAddress, guard }
}
